class MtAccessoriesCarousel {
  constructor(container) {
    this.container = container;
    this.track = container.querySelector('.mt-accessories__carousel-track');
    this.slides = container.querySelectorAll('.mt-accessories__carousel-slide');
    this.dots = container.querySelectorAll('.mt-accessories__dot');
    this.prevBtn = container.querySelector('.mt-accessories__nav-btn--prev');
    this.nextBtn = container.querySelector('.mt-accessories__nav-btn--next');
    
    this.currentSlide = 0;
    this.totalSlides = this.slides.length;
    this.autoPlayInterval = null;
    this.progressInterval = null;
    this.isAutoPlaying = true;
    this.autoPlayDelay = 5000; // 5秒
    this.isTransitioning = false;
    this.visible = 1; // 移动端显示1个slide
    
    this.init();
  }
  
  init() {
    // 先获取原始slides
    this.slides = Array.from(this.track.querySelectorAll('.mt-accessories__carousel-slide'));
    if (this.slides.length === 0) return;
    
    this.totalSlides = this.slides.length;
    
    // 移动端构建克隆用于无限循环
    this.buildClones();
    this.setupEventListeners();
    
    // 设置初始位置（移动端已经由buildClones设置，PC端设置为0）
    if (!this.isMobile()) {
      this.currentSlide = 0;
    }
    this.updateSlidePosition(false); // 初始无过渡
    
    // 延迟一帧以确保DOM完全渲染
    requestAnimationFrame(() => {
      this.updateDots();
      this.startAutoPlay();
    });
  }
  
  // 构建克隆slide用于无限循环（参考text3.liquid）
  buildClones() {
    // 只在移动端启用无限循环
    if (!this.isMobile()) return;
    
    // 清理旧克隆
    Array.from(this.track.querySelectorAll('.mt-accessories__carousel-slide.is-clone')).forEach(function(n){ n.remove(); });
    
    // 获取原始slides（不包括克隆）
    var originalSlides = Array.from(this.track.querySelectorAll('.mt-accessories__carousel-slide:not(.is-clone)'));
    if (originalSlides.length === 0) return;
    
    // 保存原始slides数组
    this.slides = originalSlides;
    var count = Math.min(this.visible, this.slides.length);
    
    // 前后各克隆 count 个
    for (var i = 0; i < count; i++){
      var tailClone = this.slides[i].cloneNode(true); 
      tailClone.classList.add('is-clone'); 
      this.track.appendChild(tailClone);
      
      var headClone = this.slides[this.slides.length - 1 - i].cloneNode(true); 
      headClone.classList.add('is-clone'); 
      this.track.insertBefore(headClone, this.track.firstChild);
    }
    
    // 更新总slide数量（包括克隆）
    this.totalSlides = this.track.querySelectorAll('.mt-accessories__carousel-slide').length;
    // 初始位置设置为第一个真实slide（前面有count个克隆）
    this.currentSlide = count;
  }
  
  // 检查是否为移动端
  isMobile() {
    return window.matchMedia('(max-width: 749px)').matches;
  }
  
  // 将索引转换为真实索引（用于dots）
  indexToReal(i) {
    if (!this.isMobile() || !this.slides) return i;
    var realCount = this.slides.length;
    var x = (i - this.visible) % realCount;
    return (x + realCount) % realCount;
  }
  
  setupEventListeners() {
    // 导航按钮事件
    if (this.prevBtn) {
      this.prevBtn.addEventListener('click', () => this.prevSlide());
    }
    if (this.nextBtn) {
      this.nextBtn.addEventListener('click', () => this.nextSlide());
    }
    
    // Dot点击事件
    this.dots.forEach((dot, index) => {
      dot.addEventListener('click', () => this.goToSlide(index));
    });
    
    // 鼠标悬停暂停自动播放
    this.container.addEventListener('mouseenter', () => this.pauseAutoPlay());
    this.container.addEventListener('mouseleave', () => this.resumeAutoPlay());
    
    // 触摸事件支持
    this.setupTouchEvents();
    
    // 监听transitionend事件处理无限循环边界跳转（参考text3.liquid）
    this.track.addEventListener('transitionend', () => {
      if (this.isMobile()) {
        this.handleInfiniteLoop();
      } else {
        // PC端也需要重置transitioning状态
        this.isTransitioning = false;
      }
    });
    
    // 窗口大小变化监听（参考text3.liquid）
    var wasMobile = this.isMobile();
    var resizeTimer = null;
    var self = this;
    window.addEventListener('resize', function() {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function() {
        var nowMobile = self.isMobile();
        if (nowMobile !== wasMobile) {
          // 移动端和PC端切换时重新初始化
          wasMobile = nowMobile;
          self.buildClones();
          if (self.isMobile()) {
            self.currentSlide = self.visible;
          } else {
            self.currentSlide = 0;
          }
          self.updateSlidePosition(false);
          self.updateDots();
        }
      }, 100);
    });
  }
  
  // 处理无限循环边界跳转（参考text3.liquid）
  handleInfiniteLoop() {
    if (!this.isMobile() || !this.slides) return;
    
    var realCount = this.slides.length;
    var total = this.track.querySelectorAll('.mt-accessories__carousel-slide').length;
    
    // 如果到达了末尾克隆区域，跳回第一个真实位置
    if (this.currentSlide >= realCount + this.visible) {
      this.currentSlide = this.visible;
      this.updateSlidePosition(false); // 无过渡跳转
    }
    // 如果到达了开头克隆区域，跳到最后真实位置
    if (this.currentSlide < this.visible) {
      this.currentSlide = realCount + this.visible - 1;
      this.updateSlidePosition(false); // 无过渡跳转
    }
    
    // 允许下一次动画
    requestAnimationFrame(() => {
      this.isTransitioning = false;
    });
  }
  
  setupTouchEvents() {
    let startX = 0;
    let startY = 0;
    let isDragging = false;
    
    this.track.addEventListener('touchstart', (e) => {
      startX = e.touches[0].clientX;
      startY = e.touches[0].clientY;
      isDragging = true;
      this.pauseAutoPlay();
    });
    
    this.track.addEventListener('touchmove', (e) => {
      if (!isDragging) return;
      
      const currentX = e.touches[0].clientX;
      const currentY = e.touches[0].clientY;
      const diffX = startX - currentX;
      const diffY = startY - currentY;
      
      // 如果水平滑动距离大于垂直滑动距离，则认为是水平滑动
      if (Math.abs(diffX) > Math.abs(diffY)) {
        e.preventDefault();
      }
    });
    
    this.track.addEventListener('touchend', (e) => {
      if (!isDragging) return;
      
      const endX = e.changedTouches[0].clientX;
      const diffX = startX - endX;
      const threshold = 50; // 滑动阈值
      
      if (Math.abs(diffX) > threshold) {
        if (diffX > 0) {
          this.nextSlide();
        } else {
          this.prevSlide();
        }
      }
      
      isDragging = false;
      this.resumeAutoPlay();
    });
  }
  
  nextSlide() {
    if (this.isTransitioning) return;
    this.isTransitioning = true;
    
    if (this.isMobile() && this.slides) {
      // 移动端无限循环：直接加1，边界由handleInfiniteLoop处理
      this.currentSlide += 1;
    } else {
      // PC端或非移动端：简单循环
      this.currentSlide = (this.currentSlide + 1) % this.totalSlides;
    }
    
    this.updateSlidePosition();
    this.updateDots();
    this.resetAutoPlay();
  }
  
  prevSlide() {
    if (this.isTransitioning) return;
    this.isTransitioning = true;
    
    if (this.isMobile() && this.slides) {
      // 移动端无限循环：直接减1，边界由handleInfiniteLoop处理
      this.currentSlide -= 1;
    } else {
      // PC端或非移动端：简单循环
      this.currentSlide = (this.currentSlide - 1 + this.totalSlides) % this.totalSlides;
    }
    
    this.updateSlidePosition();
    this.updateDots();
    this.resetAutoPlay();
  }
  
  goToSlide(index) {
    if (this.isTransitioning) return;
    this.isTransitioning = true;
    
    if (this.isMobile() && this.slides) {
      // 移动端：将真实索引转换为包含克隆的索引
      var realCount = this.slides.length;
      this.currentSlide = this.visible + index;
      // 确保索引在有效范围内
      if (this.currentSlide >= realCount + this.visible) {
        this.currentSlide = this.visible;
      }
    } else {
      // PC端或非移动端：直接使用索引
      this.currentSlide = index;
    }
    
    this.updateSlidePosition();
    this.updateDots();
    this.resetAutoPlay();
  }
  
  updateSlidePosition(withTransition = true) {
    // 每个slide占85%宽度，所以滑动距离也是85%
    const translateX = -this.currentSlide * 85;
    
    if (withTransition === false) {
      // 无过渡跳转（用于边界无缝跳转）
      this.track.style.transition = 'none';
      this.track.style.transform = `translateX(${translateX}%)`;
      // 强制重绘
      void this.track.offsetHeight;
      // 恢复过渡
      this.track.style.transition = '';
    } else {
      // 正常过渡
      this.track.style.transform = `translateX(${translateX}%)`;
    }
  }
  
  updateDots() {
    // 移动端使用真实索引，PC端使用当前索引
    var activeIndex = this.isMobile() && this.slides ? this.indexToReal(this.currentSlide) : this.currentSlide;
    
    this.dots.forEach((dot, index) => {
      const isActive = index === activeIndex;
      
      // 清除所有dot的active类
      if (!isActive) {
        dot.classList.remove('mt-accessories__dot--active');
      }
    });
    
    // 给当前dot添加active类并重启动画
    if (this.dots[activeIndex]) {
      const currentDot = this.dots[activeIndex];
      const progress = currentDot.querySelector('.mt-accessories__dot-progress');
      
      // 移除active类以重置动画
      currentDot.classList.remove('mt-accessories__dot--active');
      
      // 强制重绘以重启CSS动画
      void currentDot.offsetHeight;
      
      // 重新添加active类，触发动画
      currentDot.classList.add('mt-accessories__dot--active');
      
      // 确保progress元素的动画也重启
      if (progress) {
        progress.style.animation = 'none';
        void progress.offsetHeight;
        progress.style.animation = '';
      }
    }
  }
  
  startAutoPlay() {
    if (!this.isAutoPlaying) return;
    
    this.autoPlayInterval = setInterval(() => {
      this.nextSlide();
    }, this.autoPlayDelay);
  }
  
  pauseAutoPlay() {
    this.isAutoPlaying = false;
    if (this.autoPlayInterval) {
      clearInterval(this.autoPlayInterval);
      this.autoPlayInterval = null;
    }
  }
  
  resumeAutoPlay() {
    this.isAutoPlaying = true;
    this.startAutoPlay();
  }
  
  resetAutoPlay() {
    this.pauseAutoPlay();
    this.resumeAutoPlay();
  }
}

// 初始化所有轮播组件
document.addEventListener('DOMContentLoaded', function() {
  const carousels = document.querySelectorAll('.mt-accessories__carousel');
  carousels.forEach(carousel => {
    new MtAccessoriesCarousel(carousel);
  });
});

// 如果页面是动态加载的，也支持初始化
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', function() {
    const carousels = document.querySelectorAll('.mt-accessories__carousel');
    carousels.forEach(carousel => {
      new MtAccessoriesCarousel(carousel);
    });
  });
} else {
  const carousels = document.querySelectorAll('.mt-accessories__carousel');
  carousels.forEach(carousel => {
    new MtAccessoriesCarousel(carousel);
  });
}
